import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import { Provider as ThemeProvider } from 'rebass'
import { injectGlobal } from 'styled-components'
import { Provider as StoreProvider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

import { store } from './model/store'

injectGlobal`
body { margin: 0; }
a {
  color: inherit;
  text-decoration: none;
}
`

ReactDOM.render(
  <StoreProvider store={store}>
    <ThemeProvider>
      <Router>
        <MuiThemeProvider>
          <App />
        </MuiThemeProvider>
      </Router>
    </ThemeProvider>
  </StoreProvider>,
  document.getElementById('root'),
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js